module.exports = __webpack_public_path__ + "static/media/union_qr_code.7009297e.png";